document.addEventListener("DOMContentLoaded", function () {
    const images = document.querySelectorAll(".widget-face");

    images.forEach(function (img) {
        const randomNumber = Math.floor(Math.random() * 10) + 1;
        img.src =
            `/wp-content/themes/svenskamoten.se/static/images/widget-face-${randomNumber}.jpg`;
    });
});